import React from 'react';

import { List, ListItem, ListItemText } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';
import { SignUpButton } from './SignUpButton';

export const FAQ = () => {
  const { locale } = useIntl();

  if (locale === Locale.en) {
    return (
      <List component="ol" className={styles.list}>
        <SignUpButton />
        <ListItem className={styles.listItem}>
          <ListItemText primary="Get Kamernet premium account to respond to unlimited adverts" />
        </ListItem>
        <ListItem className={styles.listItem}>
          <ListItemText primary="Choose the plan that's right for you 15-Days, 30-Days, 3-Months" />
        </ListItem>
        <ListItem className={styles.listItem}>
          <ListItemText primary="Enter a payment method to start subscription and respond to adverts." />
        </ListItem>
      </List>
    );
  }

  return (
    <List component="ol" className={styles.list}>
      <SignUpButton />
      <ListItem className={styles.listItem}>
        <ListItemText primary="Neem een Kamernet premium account om onbeperkt te reageren op advertenties" />
      </ListItem>
      <ListItem className={styles.listItem}>
        <ListItemText primary="Kies het plan dat bij je past 15-dagen, 30-dagen, 3 maanden" />
      </ListItem>
      <ListItem className={styles.listItem}>
        <ListItemText primary="Voer een betaalmethode in om het abonnement te starten en op advertenties te reageren." />
      </ListItem>
    </List>
  );
};
